import { Button, ButtonGroup, Hero, Page } from '@hbo/ui-servicing-react-components';
import { useDataLayer } from 'react-common-gdlv2';
import { Helmet } from 'react-helmet-async';
import { Trans, useTranslation } from 'react-i18next';
import { Navigate, useBlocker, useLocation, useNavigate } from 'react-router-dom';
import { RoutePath } from 'types/global';
import { getInternalLinkElement } from 'utils/analytics';

interface LocationState {
  reason: '4QV' | 'OTP';
}

const Locked: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useTranslation();
  // const { track } = useDataLayer();

  const state = location.state as LocationState;

  let isBlocked = true;

  /** Block navigation to any other page */
  useBlocker(() => {
    return isBlocked;
  });

  if (!state?.reason) {
    return <Navigate to={RoutePath.FourQuestionVerification} replace />;
  }

  return (
    <>
      <Helmet>
        <title>{t('lockedAccount.tabTitle')}</title>
      </Helmet>
      <Hero>
        <Hero.PrimaryContent title={<Trans i18nKey="lockedAccount.title" />} />
      </Hero>
      <Page>
        <Page.Content>
          {state.reason === '4QV' && (
            <>
              <p>{t('4qv.error.locked.line1')}</p>
              <p>{t('4qv.error.locked.line2')}</p>
              <p>{t('4qv.error.locked.line3')}</p>
            </>
          )}
          {state.reason === 'OTP' && (
            <>
              <p>{t('oneTimePasscode.error.locked.line1')}</p>
              <p>{t('oneTimePasscode.error.locked.line2')}</p>
              <p>{t('oneTimePasscode.error.locked.line3')}</p>
            </>
          )}
          <ButtonGroup>
            <Button
              variant="secondary"
              onClick={(event: React.MouseEvent<Element, MouseEvent>) => {
                // const pageName = t('lockedAccount.tabTitle');
                // track(
                //   `CLICK: ${pageName} - ${t('generic.backToLogin')} - Button`,
                //   getInternalLinkElement(event),
                //   pageName
                // );
                isBlocked = false;
                navigate(RoutePath.FourQuestionVerification);
              }}
            >
              {t('generic.backToLogin')}
            </Button>
          </ButtonGroup>
        </Page.Content>
      </Page>
    </>
  );
};

export default Locked;
